import { cn } from '@elara/client-core/lib/utils';

/**
 * A guide's tinted band, for the part of a guide the traveller acts in (a hotel's Find rooms, a room's
 * rates): the secondary background. It runs out to the panel's sides, clipped by its scroller, and
 * down through the panel's bottom padding (`p-4 md:p-8` in `PreviewPanel`), so it belongs on a guide's
 * LAST block. The caller sets where it starts (`before:top-*`). Painted by a pseudo-element, as the
 * content keeps the guide's width; `isolate` holds its `-z-10` behind the block's content rather than
 * the panel.
 */
export const GUIDE_BAND_CLASSES = cn(
  'relative isolate',
  'before:absolute before:-inset-x-[100vw] before:-bottom-4 before:-z-10 md:before:-bottom-8',
  'before:bg-background-secondary',
);
